import script from "./SectionStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionStatus.vue?vue&type=script&setup=true&lang=js"

import "./SectionStatus.vue?vue&type=style&index=0&id=3d8e04a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d8e04a5"]])

export default __exports__